import { mdiClockAlert } from '@mdi/js'

export default {
  title: 'Attendance',
  to: 'attendance-headmaster',
  icon: mdiClockAlert,
  resource: 'AttendanceHeadMaster',
  action: 'read',
}
